import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * AdManager Component
 * 
 * This component handles refreshing ads when routes change.
 * It should be placed near the top of your component hierarchy.
 */
const AdManager = ({ children }) => {
  const location = useLocation();
  const initialized = useRef(false);
  const refreshing = useRef(false);

  // Function to safely handle ad refresh
  const refreshAds = () => {
    // Skip if already refreshing
    if (refreshing.current) return;

    try {
      refreshing.current = true;

      // Only try to refresh if window.adsbygoogle exists
      if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
        // Clear existing ads first
        document.querySelectorAll('ins.adsbygoogle').forEach(ad => {
          // Remove the 'data-ad-status' attribute to allow reinitializing
          ad.removeAttribute('data-ad-status');
          // Clear the contents
          ad.innerHTML = '';
        });

        // Refresh the ads with a slight delay to ensure DOM is ready
        setTimeout(() => {
          try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          } catch (e) {
            // Log silent error or handle gracefully
          } finally {
            refreshing.current = false;
          }
        }, 100);
      }
    } catch (error) {
      refreshing.current = false;
    }
  };

  useEffect(() => {
    // Initialize Google AdSense if not already initialized
    if (!initialized.current && typeof window !== 'undefined') {
      initialized.current = true;

      // Wait for the DOM to be fully ready
      setTimeout(() => {
        refreshAds();
      }, 200);
    } else {
      // If already initialized, just refresh the ads
      refreshAds();
    }
  }, [location.pathname]); // Refresh ads whenever the path changes

  return <>{children}</>;
};

export default AdManager; 